import React from 'react';
import { createRoot } from 'react-dom/client';
import '@cloudscape-design/global-styles/index.css';
import { configureAmplify } from './config/amplify';
import App from './App';

configureAmplify();

// Registers the OAuth code-exchange listener for the Google sign-in redirect.
import 'aws-amplify/auth/enable-oauth-listener';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
